import styled from 'styled-components'
import { Separator as BaseSeparator } from '@sketch/components'
import AnnotationListWrapper from '../AnnotationListWrapper'

export const AnnotationInboxListWrapper = styled(AnnotationListWrapper).attrs({
  'data-testid': 'annotation-list',
})`
  height: 100%;
`

export const Separator = styled(BaseSeparator)`
  margin: 8px 12px;
`
